export default class CreateTpPaymentRefundItem {
  constructor() {
    this.TpClientPaymentId = '';
    this.RefundedOn = new Date();
    this.ReasonCode = '';
    this.MethodCode = '';
    this.Amount = '';
    this.TransactionReference = '';
    this.Comment = '';
  }
}
